import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-view-resto',
  templateUrl: './view-resto.component.html',
  styleUrls: ['./view-resto.component.scss']
})
export class ViewRestoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
